export default __webpack_public_path__ + "static/media/gif3.777db047.gif";